import xtreamAPI from '../api/xtreamAPI';
import { clearCatalogCache } from './cacheUtils';
import { invalidateLiveStreamsCache } from './liveStreamsCache';
import { invalidateSeriesStreamsCache } from './seriesStreamsCache';
import { invalidateVodStreamsCache } from './vodStreamsCache';
import { invalidateXtreamCategoriesCache } from './xtreamCategoriesCache';

const FORCE_REFRESH_PREFIX = 'ott_catalog_force_refresh:';
const FORCE_REFRESH_WINDOW_MS = 5 * 60 * 1000;

export function refreshXtreamCatalogCache(): void {
  clearCatalogCache();
  invalidateLiveStreamsCache();
  invalidateVodStreamsCache();
  invalidateSeriesStreamsCache();
  invalidateXtreamCategoriesCache();
  xtreamAPI.clearRuntimeCache();
  try {
    localStorage.setItem(`${FORCE_REFRESH_PREFIX}all`, String(Date.now()));
  } catch {}
}

export function markCatalogBackendForceRefresh(): void {
  try { localStorage.setItem(`${FORCE_REFRESH_PREFIX}all`, String(Date.now())); } catch {}
}

export function consumeCatalogForceRefresh(scope: string): boolean {
  try {
    const allKey = `${FORCE_REFRESH_PREFIX}all`;
    const scopedKey = `${FORCE_REFRESH_PREFIX}${scope}`;
    const now = Date.now();
    const allAt = Number(localStorage.getItem(allKey) || 0);
    const scopedAt = Number(localStorage.getItem(scopedKey) || 0);
    const shouldForce =
      (allAt > 0 && now - allAt <= FORCE_REFRESH_WINDOW_MS) ||
      (scopedAt > 0 && now - scopedAt <= FORCE_REFRESH_WINDOW_MS);
    if (shouldForce) {
      localStorage.removeItem(scopedKey);
      return true;
    }
    if (allAt > 0 && now - allAt > FORCE_REFRESH_WINDOW_MS) localStorage.removeItem(allKey);
    if (scopedAt > 0 && now - scopedAt > FORCE_REFRESH_WINDOW_MS) localStorage.removeItem(scopedKey);
  } catch {}
  return false;
}
